export default __webpack_public_path__ + "static/media/action-edit_white.5b0c6986.svg";